<script setup lang="ts">
import { cn } from "~/lib/utils"
import type { TavoWidgetModeValue, TavoWidgetReferrerValue } from "."
import { TavoClickUrl, useTavo } from "."

const { group, concept, location, mode, referrer } = defineProps<{
    group: string | number
    concept?: string
    location?: string
    mode?: TavoWidgetModeValue
    referrer?: TavoWidgetReferrerValue
}>()

const href = computed(() => {
    const url = new URL(TavoClickUrl)
    url.searchParams.set("group", group.toString())
    if (concept) url.searchParams.set("concept", concept)
    if (location) url.searchParams.set("location", location)
    if (mode) url.searchParams.set("mode", mode)
    if (referrer) url.searchParams.set("referrer", referrer)
    return url.toString()
})

const { tavoReady } = useTavo()

const cloner = useTemplateRef("cloner")
const link = useTemplateRef("link")

const trigger = computed(() => cloner.value?.firstElementChild)
const cl = computed(() => trigger.value?.className)
const text = computed(() => (trigger.value?.firstElementChild || trigger.value)?.innerHTML)

defineExpose({
    ready: tavoReady,
    click: () => {
        if (link.value) {
            link.value.click()
        }
    }
})
</script>

<template>
    <div
        ref="cloner"
        class="hidden"
    >
        <slot />
    </div>
    <a
        ref="link"
        :href
        :class="cn(cl)"
        tabindex="0"
        @click="e => e.preventDefault()"
    >
        {{ text }}
    </a>
</template>